import React from 'react';
import Helmet from 'react-helmet';

import favicon from '../../images/favicon.png';

export default ({ title, description, keywords, url }) => {
  return (
    <Helmet
      title={title}
      meta={[
        { name: 'description', content: description },
        { name: 'keywords', content: keywords },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: url },
        { property: 'og:image', content: 'https://s3.amazonaws.com/cdn.quickpageapp.com/public/marketing/quickpagere-facebook-thumb.jpg' },
        { property: 'og:image:secure_url', content: 'https://s3.amazonaws.com/cdn.quickpageapp.com/public/marketing/quickpagere-facebook-thumb.jpg' },
        { property: 'og:image:width', content: '1200' },
        { property: 'og:image:height', content: '630' },
      ]}
      link={[
        {
          rel: 'icon',
         type: 'image/png',
         href: favicon
        }
      ]}
    />
  )
}
